module.exports = __webpack_public_path__ + "img/Anhänger_Sp_2t.670a4a1e.svg";